import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { DestinationInput } from '@redirector/shared';
import { apiSend } from '../lib/api.js';
import { entryKeys } from '../domains/queries.js';

export function useSaveDestinations(entryId: number) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (destinations: DestinationInput[]) =>
      apiSend<{ destinations: unknown[] }>('PUT', `/api/entries/${entryId}/destinations`, {
        destinations,
      }),
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: entryKeys.one(entryId) });
      void client.invalidateQueries({ queryKey: ['domains'] });
    },
  });
}
